import styled, { css, keyframes } from "styled-components";
import media from "@pagepro-monorepo/ui/lib/theme/config/media";

import { StyledTestimonialsProps } from "./types";
import { SLIDE_CHANGE_TIME } from "./consts";

const progress = keyframes`
  0% {
    transform: translateX(0)
  }
  100% {
    transform: translateX(100%)
  }
`;

export const MainWrapper = styled.div`
  width: 100%;
  position: relative;
`;

export const Wrapper = styled.div`
  position: relative;
`;

export const Viewport = styled.div`
  overflow: hidden;
  width: 100%;
  &.is-draggable {
    cursor: move;
    cursor: grab;
  }
  &.is-dragging {
    cursor: grabbing;
  }
`;

export const Container = styled.div`
  display: flex;
  user-select: none;
  -webkit-touch-callout: none;
  -khtml-user-select: none;
  -webkit-tap-highlight-color: transparent;
  margin-left: -0.625rem;
`;

export const Slide = styled.div`
  padding-left: 0.625rem;
  min-width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const NavigationWrapper = styled.div`
  margin-top: ${({ theme }) => theme.space.L};
  display: flex;
  align-items: center;
  justify-content: center;
  @media ${media.mobile} {
    justify-content: space-between;
  }
  @media ${media.tablet} {
    justify-content: center;
  }
`;

export const NavigationViewport = styled.div`
  width: 100%;
  @media ${media.mobile} {
    width: auto;
    flex-grow: 1;
  }
  @media ${media.tablet} {
    width: 100%;
  }
`;

export const Bullets = styled.ul`
  display: flex;
  justify-content: center;
`;

export const Bullet = styled.li<StyledTestimonialsProps>`
  max-width: 22.25rem;
  width: 100%;
  visibility: ${({ isActive }) => (isActive ? "visible" : "hidden")};
  opacity: ${({ isActive }) => (isActive ? 1 : 0)};
  transition: ${({ theme }) => theme.transition};
  display: ${({ isActive }) => (isActive ? "flex" : "none")};
  flex-direction: column;

  @media ${media.tablet} {
    display: flex;
    visibility: visible;
    opacity: 1;
  }
`;

export const ArrowButton = styled.button`
  padding: 0;
  border: 0;
  background-color: transparent;
  color: ${({ theme }) => theme.colors.primary};
  flex-shrink: 0;
  &:disabled,
  &[disabled] {
    opacity: 0.3;
    pointer-events: none;
  }
  display: none;
  svg {
    fill: currentColor;
    height: 1em;
    width: 1.3em;
    font-size: 0.875rem;
  }
  @media ${media.mobile} {
    display: flex;
  }
  @media ${media.tablet} {
    display: none;
  }
`;

export const ProgressBarWrapper = styled.div`
  height: 0.125rem;
  width: 100%;
  position: relative;
  overflow: hidden;
  background-color: transparent;
  margin-bottom: -0.125rem;
  z-index: 1;
`;

export const ProgressBar = styled.div<StyledTestimonialsProps>`
  width: 100%;
  background-color: ${({ theme }) => theme.colors.white};
  height: 100%;
  position: absolute;
  top: 0;
  left: -100%;
  transition: ${({ theme }) => theme.transition};
  ${({ isActive }) =>
    isActive &&
    css`
      animation: ${progress} ${SLIDE_CHANGE_TIME}ms linear;
    `}
`;
